import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import Hero from 'components/hero/BackgroundAsImage.js';
import Features from 'components/features/DashedBorderSixFeatures';
import MainFeature from 'components/features/TwoColSingleFeatureWithStats2.js';
import Blog from 'components/blogs/ThreeColSimpleWithImageAndDashedBorder.js';
import Testimonial from 'components/testimonials/TwoColumnWithImageAndProfilePictureReview.js';
import ContactUsForm from 'components/forms/TwoColContactUsWithIllustration.js';
import Footer from 'components/footers/MiniCenteredFooter.js';
import user from '../images/user.png';
import testimonial1 from '../images/testimonial1.jpg';
import testimonial2 from '../images/testimonial2.jpg';

export default () => (
  <AnimationRevealPage>
    <Hero />
    <MainFeature />
    <Features />
    <Testimonial
      subheading='Testimonials'
      heading={
        <>
          What people are saying <span tw='text-primary-500'>About Us.</span>
        </>
      }
      description='Here are what some of our amazing clients and parents are saying about our school.'
      testimonials={[
        {
          imageSrc: testimonial2,
          profileImageSrc: user,
          quote:
            'BHS has transformed my child’s education. The dedicated teachers and diverse extracurricular activities have truly enriched their learning experience.',
          customerName: 'Lupa Nyalandu',
          customerTitle: 'Parent',
        },
        {
          imageSrc: testimonial1,
          profileImageSrc: user,
          quote:
            'The supportive environment at BHS has fostered my child’s growth academically and personally. I couldn’t be happier with their progress.',
          customerName: 'Fatma Mwakalukwa',
          customerTitle: 'Parent',
        },
      ]}
      textOnLeft={true}
    />
    <Blog />
    <ContactUsForm />
    <Footer />
  </AnimationRevealPage>
);
